/*
创建者 汪露(2020.08.30)
联盟商家申请状态
*/
联盟商家
<template>
  <div style="margin-bottom: 20px">
    <div class="layout-block">
      <div class="left-content">
        <img
          :src='leftContentImg'
          class="img"
        >
      </div>
      <div class="right-content">
        <div class="layout">
          <div
            class="main"
            v-show='showPage'
          >
            <div class="wrap">
              <div class="open-store">
                <h1>欢迎来到开心云商商家中心</h1>
                <p v-if='applyStatus == 1'>您的申请正在审核中，请耐心等待...</p>
                <p v-else-if='applyStatus == 2'>你已经是联盟商家，编号：{{sn}}</p>
                <p v-else-if='applyStatus == 4'>联盟商家已禁用，请联系管理员...</p>
                <div v-else-if='applyStatus == 3'>
                  <p>抱歉，您的申请未通过.......</p>
                  <div>原因: {{notPassReason}}</div>
                  <div>
                    <dt v-if="checked">
                      <router-link :to="{path:'/applyLeague'}">点击修改申请</router-link>
                    </dt>
                    <dt v-else>
                      <span>点击修改申请</span>
                    </dt>
                  </div>
                  <div>
                    <Checkbox v-model="checked"></Checkbox><span style="font-size: 14px;">我已阅读并同意<span
                        style="color: #1e80ff;cursor: pointer;"
                        @click.stop="docPage"
                      >《联盟商家入驻服务协议》</span></span>
                  </div>
                </div>
                <div v-else>
                  <h3>您现在还不是联盟商家，您可以：</h3>
                  <div>
                    <em></em>
                    <dl>
                      <dt v-if="checked">
                        <router-link :to="{path:'/applyLeague'}">马上申请联盟商家</router-link>
                      </dt>
                      <dt v-else>
                        <span>马上申请联盟商家</span>
                      </dt>
                      <dd>填写相关信息，即可免费成为联盟商家。</dd>
                    </dl>
                    <!-- <div class="clear"></div> -->
                  </div>
                  <div>
                    <Checkbox v-model="checked"></Checkbox><span style="font-size: 14px;">我已阅读并同意<span
                        style="color: #1e80ff;cursor: pointer;"
                        @click.stop="docPage"
                      >《联盟商家入驻服务协议》</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-img-block">
      <div style="background: #E8F1F8;padding: 8px 10px;">申请联盟商家需要以下资料</div>
      <div class="apply-img">
        <div class="apply-img-left">
          <div class="apply-img-box">
            <img
              class="apply-img-url"
              :src="businessLicence"
              alt=""
            >
            <div class="marker">例</div>
          </div>

          <div class="apply-text">
            <div class="title">营业执照</div>
            <div>需要拍照原件或盖章复印件，证照需要在有效期内。</div>
          </div>
        </div>
        <div class="apply-img-left">
          <div class="apply-img-box">
            <img
              class="apply-img-url"
              style="width: 80%;display: inherit;margin: auto;"
              :src="identityCard"
              alt=""
            >
            <div class="marker">例</div>
          </div>
          <div class="apply-text">
            <div class="title">身份证(正反面)</div>
            <div>法定代表人/经营者身份证</div>
          </div>
        </div>
      </div>
      <div class="apply-img">
        <div class="apply-img-left">
          <div class="apply-img-box">
            <img
              class="apply-img-url"
              :src="doorHeadPhoto"
              alt=""
            >
            <div class="marker">例</div>
          </div>

          <div class="apply-text">
            <div class="title">门头照<span style="font-size: 14px; font-weight: 500;margin-left:5px">x1</span></div>
            <div>必须为正面全景照。包含完整店名和入口，且店名要与填写的店名一致。</div>
          </div>
        </div>
        <div class="apply-img-left">
          <div class="apply-img-box">
            <img
              class="apply-img-url"
              :src="interior"
              alt=""
            >
            <div class="marker">例</div>
          </div>
          <div class="apply-text">
            <div class="title">内景照</div>
            <div>需拍摄真是门店环境（如服务场景、工作台、用餐环境等）。</div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>
<script>
import { isApplyLeague } from "api/user";

export default {
  data() {
    return {
      checked: true,
      sn: "",
      applyStatus: "",
      notPassReason: "",
      showPage: false,
      leftContentImg: require("../../assets/images/create-league-logo.png"),
      businessLicence: require("../../assets/images/business_licence.png"),
      doorHeadPhoto: require("../../assets/images/door_head_photo.png"),
      interior: require("../../assets/images/interior.png"),
      identityCard: require("../../assets/images/identity_card.png"),
    };
  },
  created() {
    this.init();
    this.isApplyLeague();
  },
  methods: {
    docPage() {
      this.$router.push("/leagueAgreement");
    },
    init() {
      if (!this.$route.query.status) {
        this.status = 1;
      } else {
        this.status = Number(this.$route.query.status);
      }
    },
    //查询是否申请过联盟商家
    isApplyLeague() {
      isApplyLeague({}).then((res) => {
        if (res.resCode == 1) {
          if (res.data) {
            this.sn = res.data.sn;
            this.applyStatus = res.data.status;
            this.notPassReason = res.data.notPassReason;
            if (this.applyStatus == 2) {
              this.$router.push({
                path: "/myData/businessLeague",
                query: { status: this.status, page: "businessLeague" },
              });
            }
          } else {
            this.applyStatus = null;
          }
          this.showPage = true;
        }
      });
    },
    routerTo() {
      this.$router.push({
        path: "/applyLeague",
      });
    },
  },
};
</script>
<style lang="less" scoped="scoped">
.layout-block {
  display: flex;
  width: 1190px;
  margin: auto;
  .left-content {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    .img {
      width: 300px;
    }
  }

  .right-content {
    width: 50%;
    margin-top: 10px;
    .layout {
      position: relative;
      overflow: hidden;
      margin: 0;
      padding: 0;
      z-index: 0;
      .main {
        padding: 0;
        background: transparent;
        .wrap {
          background-color: #fff;
          clear: both;
          margin: 0;
          padding: 12px;
          .open-store {
            padding: 20px;
            overflow: hidden;
            min-height: 190px;
            h1 {
              font-family: "微软雅黑";
              color: #4384b7;
              font-size: 28px;
              line-height: 40px;
            }
            h3 {
              font-weight: normal;
              color: #777;
              font-size: 14px;
              line-height: 32px;
            }
            dl {
              float: left;
              dt > .link {
                font-family: "微软雅黑";
                color: #333;
                line-height: 28px;
                font-size: 20px;
                font-weight: 700;
                text-decoration: none;
              }
              dd {
                color: #888;
                line-height: 20px;
                font-size: 12px;
                font-weight: 400;
              }
            }
            p {
              width: 100%;
              height: 30px;
              line-height: 30px;
              margin-top: 20px;
              font-weight: bold;
              font-size: 16px;
              color: #666;
            }
            div {
              padding: 30px 0;
              margin: 0;
              font-weight: bold;
              font-size: 16px;
              color: #666;
            }
            .link {
              color: #0579c6;
            }
            .link:hover {
              text-decoration: underline;
              color: #d93600;
            }
          }
        }
      }
    }
  }
}

.apply-img-block {
  width: 1190px;
  margin: auto;
  .apply-img {
    display: flex;
    margin-top: 20px;

    .apply-img-left {
      width: 50%;
      display: flex;
      align-items: center;

      .apply-img-box {
        box-sizing: border-box;
        border: 1px solid #ccc;
        width: 260px;
        height: 180px;
        position: relative;
        .apply-img-url {
          width: 260px;
          height: 180px;
        }
        .marker {
          position: absolute;
          width: 30px;
          height: 30px;
          top: 0;
          left: 0;
          text-align: center;
          line-height: 30px;
          background: #e40303;
          color: #fff;
        }
      }

      .apply-text {
        padding: 0 20px;
      }
    }
    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 5px;
    }
  }
}

.layout-block:after {
  display: block;
  content: ".";
  clear: both;
  font-size: 0;
  line-height: 0;
  height: 0;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// createLeague.vue?b90dbabc